import { createAction } from "@reduxjs/toolkit";

const FETCHING_PROVINCE_LIST = 'FETCHING_PROVINCE_LIST';
const FETCHING_DISTRICT_LIST = 'FETCHING_DISTRICT_LIST';
const FETCHING_WARD_LIST = 'FETCHING_WARD_LIST';
const FETCHING_MODULE_LIST = 'FETCHING_MODULE_LIST';
const FETCHING_BANK_SUPPORT_LIST = 'FETCHING_BANK_SUPPORT_LIST';
const FETCHING_SCHOOL_MODULE_LIST = 'FETCHING_SCHOOL_MODULE_LIST';
const FETCHING_USER_DETAIL = 'user/fetchUserDetail';
const FETCH_NEW_WARD_LIST = 'FETCH_NEW_WARD_LIST'
export const fetchProviceList = createAction(FETCHING_PROVINCE_LIST);
export const fetchDistrictList = createAction(FETCHING_DISTRICT_LIST, (provinceId: string) => ({
  payload: { provinceId: provinceId }
}));
export const fetchWardList = createAction(FETCHING_WARD_LIST, (districtId: string) => ({
  payload: { districtId: districtId }
}));
export const fetchModuleList = createAction(FETCHING_MODULE_LIST, (filters: any) => ({
  payload: { filters },
}))
export const fetchBankSupportList = createAction(FETCHING_BANK_SUPPORT_LIST);
export const fetchSchoolModuleList = createAction(FETCHING_SCHOOL_MODULE_LIST, (filters: any) => ({
  payload: { filters },
}))
export const fetchUserDetail = createAction(FETCHING_USER_DETAIL,(id: number) => ({
  payload: { id },
}));

export const fetchNewWardList = createAction(FETCH_NEW_WARD_LIST, (provinceId: string) => ({
    payload: { provinceId }
}));